import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const SelectOrganisationAdminListOrganisationFragmentDoc = gql`
  fragment SelectOrganisationAdminListOrganisation on OrganisationInterface {
    id
    name
    isVerified
    parent {
      id
      name
    }
  }
` as unknown as DocumentNode<Types.SelectOrganisationAdminListOrganisationFragment, unknown>
